/**
 * Ryan O'Dowd
 * 2023-08-02
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    translationSelectionWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      minWidth: 500,
    },
    emptyText: {
      color: colors.dialogText,
    },
  };
};

export default getStyles;
